module.exports = __webpack_public_path__ + "static/media/close_icon_blue.a58c38b4.svg";